import { useMutation, useQuery } from '@tanstack/react-query';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import { deleteData, getData, sendData } from '../fetchers';

export const useSetUnavailableMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('unavailability/:courtId', data, params, queryParams),
    onSuccess: (data) => notify.success(tr(data?.translationKey) || data?.message),
  });
};

export const useGetUnavailablePeriodsQuery = (params) =>
  useQuery({
    queryKey: ['unavailable-periods', params?.params],
    queryFn: () => getData('unavailability/:courtId', params?.params),
    select: (data) => data?.data,
    retry: 1,
    ...params,
  });

export const useCancelUnavailabilityMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      deleteData('unavailability/:courtId/:periodId', data, params, queryParams),
    onSuccess: (data) => notify.success(tr(data?.translationKey) || data?.message),
  });
};
